<template>
  <div class="card">
    <div class="card-img-top">
      <img
          class="special_img card-img-top"
          :src="image"
          :alt="alt"
      />
    </div>
    <div class="card-body">

      <slot name="p-1"/>

    </div>
  </div>
</template>

<script>
export default {
  name: "C302",
  props: {
    image: {
      default: 'https://picsum.photos/1280/720'
    },
    alt: {
      default: 'mix it web'
    },
  }
}
</script>

<style scoped>
.card {
  height: 100%;
}

.custom-font-size {
  font-size: 14px !important;
}

.badge-danger {
  background: var(--secondary) !important;
}

.special_img {
  object-fit: cover;
  height: 250px;
}

</style>